import { useTheme } from "@mui/material/styles";

export const InfoIcon = () => {
  const { palette } = useTheme();
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.999 8C11.861 8 11.749 8.112 11.75 8.25C11.75 8.388 11.862 8.5 12 8.5C12.138 8.5 12.25 8.388 12.25 8.25C12.25 8.112 12.138 8 11.999 8"
        stroke={palette.text.secondary}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 23.5C5.64814 23.5 0.5 18.3519 0.5 12C0.5 5.64814 5.64814 0.5 12 0.5C18.3519 0.5 23.5 5.64814 23.5 12C23.5 18.3519 18.3519 23.5 12 23.5Z"
        stroke={palette.divider}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12V17"
        stroke={palette.text.secondary}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InfoIcon;
